import { Box } from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    noPaddingBottom?: boolean;
}

export function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, noPaddingBottom, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            className={`custumTabPanel ${noPaddingBottom ? 'nopaddingBottomTab' : ''}`}
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}